import { createEdgeSpark } from "@edgespark/client";
import { env } from "../config/env";

export const client = createEdgeSpark({ baseUrl: env.WORKER_URL });
